import { authFetch } from "./authFetch";

const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";


export const ServiceData = async (
  url: string,
  method: string,
  data?: any
): Promise<any> => {
  const urldata = `${API_URL}${url}`;
  const options: RequestInit = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    ...(data && { body: JSON.stringify(data) }),
  };
 

  const response = await authFetch(urldata, options);

  if (response.status === 401) {
    throw new Error("Non autorisé : token invalide");
  }

  if (!response.ok) {
    throw new Error(`Erreur serveur : ${response.status}`);
  }
  return await response.json(); 
};
